import { render } from "./ModalPlanilhaLubrificanteTransmissao.vue?vue&type=template&id=23fc5d64&ts=true"
import script from "./ModalPlanilhaLubrificanteTransmissao.vue?vue&type=script&lang=ts"
export * from "./ModalPlanilhaLubrificanteTransmissao.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__